import GameMultiplier from '@/components/core/Games/Multiplier';
import { GameRoundStatusId } from '@/models/round/status/id';
import { Either } from '@starsoft/common/interfaces';
import { Decimal } from '@starsoft/common/services/Decimal';
import useTranslation from 'next-translate/useTranslation';
import { useEffect, useMemo } from 'react';
import { useCountUp } from 'use-count-up';
import { CrashAreaChart } from './AreaChart';
import { CrashChartData } from './AreaChart/props';
import { CrashBoardContentProps } from './props';
import styles from './styles.module.scss';
import { getTicks } from './utils';

export default function CrashBoardContent({
  lines,
  round,
  status,
  shouldShowLastWinnerBets,
}: CrashBoardContentProps) {
  const { t } = useTranslation('smash-racing');
  const isMultiplierVisible: boolean =
    status?.id?.toString() === GameRoundStatusId.Rising?.toString() ||
    status?.id?.toString() === GameRoundStatusId.Crashed?.toString();
  const isClosed =
    status?.id?.toString() === GameRoundStatusId.Crashed?.toString();

  const formatedData: CrashChartData[] = useMemo(
    () =>
      lines.map(line => ({
        line,
      })),
    [lines],
  );

  const multiplier: Either<Decimal, undefined> = useMemo(
    () =>
      round?.crash?.crashpoint ? round?.crash?.crashpoint : new Decimal(0),
    [round?.crash?.crashpoint],
  );
  const lastMultiplier: Either<Decimal, undefined> = useMemo(
    () =>
      round?.crash?.previousCrashpoint
        ? round?.crash?.previousCrashpoint
        : new Decimal(0),
    [round?.crash?.previousCrashpoint],
  );

  const { value: interpoledMultiplier, reset } = useCountUp({
    decimalPlaces: 2,
    duration: 0.25,
    isCounting: true,
    start: Math.max(1, lastMultiplier?.toNumber() ?? 1),
    end: multiplier?.toNumber() ?? 0,
  });
  useEffect(reset, [lastMultiplier, multiplier, reset]);

  const customTicks = useMemo(
    () => getTicks(multiplier?.toNumber() ?? 0),
    [multiplier],
  );

  return (
    <div
      className={`${styles.container} ${shouldShowLastWinnerBets ? styles['container--with-last-winner-bets'] : ''}`}
    >
      <CrashAreaChart
        data={formatedData}
        status={status}
        customTicks={customTicks}
        shouldShowLastWinnerBets={shouldShowLastWinnerBets}
      />

      {isMultiplierVisible && (
        <GameMultiplier
          shouldShowLastWinnerBets={shouldShowLastWinnerBets}
          color={round?.crash?.tileType?.color}
          isClosed={isClosed}
          multiplier={interpoledMultiplier as unknown as number}
          text={t('crash_label')}
        />
      )}
    </div>
  );
}
